import { types } from 'mobx-state-tree';


const INTENT_TYPES = {
    PLAN_TO_SELL: 'i-have-not-yet-sold-the-property-but-plan-to',
    SALE_AGREEMENT_SIGNED: 'i-have-sold-the-property-sale-agreement-signed',
    WILL_KEEP: 'i-will-keep-it',
};

const IntentTypeEnum = types.enumeration('IntentType', Object.values(INTENT_TYPES));

export {
    IntentTypeEnum,
};
export default INTENT_TYPES;
